import { render, staticRenderFns } from "./UpdateOpportunite.vue?vue&type=template&id=320a7799&"
import script from "./UpdateOpportunite.vue?vue&type=script&lang=ts&"
export * from "./UpdateOpportunite.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateOpportunite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports